import React from 'react';
import MainComposer from './MainComposer'

function WorksByComposerIndex({composers, nativeLinks}) {
  const musicEraAndComposerList = composers.map((era, index) => {
    const composerList = era.composers.map((composer) => {
      if (composer && Array.isArray(composer.works) && composer.works.length > 0) {
        return <>
          <MainComposer composer={composer} nativeLinks={nativeLinks} />
          <hr/>
        </>
      }

      return undefined;
    });

    return (
      <div key={`era-${index}`}>
        <h1 className="musicEra">
          {era.era}
        </h1>
        <div>{composerList}</div>
        {/* <hr/> */}
      </div>
    )
  });

  return (
    <div>
      {musicEraAndComposerList}
    </div>
  );
}

export default WorksByComposerIndex
